window.AECurrencyConverter = (function() {
  // Private function for number formatting
  function formatNumber(number, decimalSeparator, thousandsSeparator) {
    const parts = number.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return parts.join(decimalSeparator);
  }

  // Private function to update a single element
  function updateSingleElement(element) {
    try {
      const initialText = element.getAttribute('data-original-price') || element.innerText;
      const currentRate = Shopify.currency.rate;
      const currentCurrency = Shopify.currency.active;
      
      // Extract the currency symbol, numeric value, and decimal separator
      const match = initialText.match(/^(\D*)([\d.,]+)(\D*)$/);
      if (!match) return;
      
      const [, prefix, amount, suffix] = match;
      const decimalSeparator = amount.includes(',') ? ',' : '.';
      const thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
      
      // Convert the price
      const baseRate = parseFloat(amount.replace(thousandsSeparator, '').replace(decimalSeparator, '.'));
      const convertedRate = Math.ceil(baseRate * currentRate);
      const formattedRate = formatNumber(convertedRate, decimalSeparator, thousandsSeparator);
      
      // Update the element
      element.innerText = `${prefix}${formattedRate}${suffix}`;
      
      // Store original price and mark as updated
      element.setAttribute('data-currency-updated', currentCurrency);
      if (!element.hasAttribute('data-original-price')) {
        element.setAttribute('data-original-price', initialText);
      }

      return true;
    } catch (error) {
      console.error('Error updating price:', error);
      return false;
    }
  }

  // Public API
  return {
    // Initialize the converter
    init: function(options = {}) {
      const defaultOptions = {
        selector: '.money', // Default selector
        onUpdate: null,     // Callback after update
        debug: false        // Debug mode
      };

      this.settings = { ...defaultOptions, ...options };

      if (this.settings.debug) {
        console.log('Currency Converter initialized with settings:', this.settings);
      }

      // Set up currency change listener
      document.addEventListener('currency:change', () => {
        this.resetAndUpdate();
      });

      // Initial conversion
      this.updatePrices();
    },

    // Update all matching price elements
    updatePrices: function(customSelector) {
      const selector = customSelector || this.settings?.selector || '.money';
      const elements = document.querySelectorAll(`${selector}:not([data-currency-updated])`);
      
      let updatedCount = 0;
      elements.forEach(element => {
        if (updateSingleElement(element)) {
          updatedCount++;
          if (this.settings?.onUpdate) {
            this.settings.onUpdate(element);
          }
        }
      });

      if (this.settings?.debug) {
        console.log(`Updated ${updatedCount} price elements`);
      }

      return updatedCount;
    },

    // Convert a single price without DOM element
    convertPrice: function(price) {
      const dummyElement = document.createElement('span');
      dummyElement.innerText = price;
      updateSingleElement(dummyElement);
      return dummyElement.innerText;
    },

    // Reset all conversions and update
    resetAndUpdate: function(selector) {
      const elements = document.querySelectorAll(selector || this.settings?.selector || '.money');
      elements.forEach(element => {
        if (element.hasAttribute('data-currency-updated')) {
          element.removeAttribute('data-currency-updated');
        }
      });
      return this.updatePrices(selector);
    },

    // Get the original price of an element
    getOriginalPrice: function(element) {
      return element.getAttribute('data-original-price') || element.innerText;
    }
  };
})();